import { useEventTracker } from '@applyboard/ui-utils';
export function useRequirementListEventTracker() {
  var eventPrefix = 'Single Application V2 - Applicant Requirements - ';
  var _useEventTracker = useEventTracker(),
    trackEventBase = _useEventTracker.trackEvent;
  var trackEvent = function trackEvent(event) {
    return trackEventBase({
      event: "".concat(eventPrefix).concat(event.event),
      data: event.data,
      group: 'Single Application V2'
    });
  };
  return {
    trackEvent: trackEvent
  };
}
export function useSideBarEventTracker() {
  var eventPrefix = 'Single Application V2 - Sidebar - ';
  var _useEventTracker2 = useEventTracker(),
    trackEventBase = _useEventTracker2.trackEvent;
  var trackEvent = function trackEvent(event) {
    return trackEventBase({
      event: "".concat(eventPrefix).concat(event.event),
      data: event.data,
      group: 'Single Application V2'
    });
  };
  return trackEvent;
}
export function useNotesEventTracker() {
  var eventPrefix = 'Single Application V2 - Notes - ';
  var _useEventTracker3 = useEventTracker(),
    trackEventBase = _useEventTracker3.trackEvent;
  var trackEvent = function trackEvent(event) {
    return trackEventBase({
      event: "".concat(eventPrefix).concat(event.event),
      data: event.data,
      group: 'Single Application V2',
      error: event.error
    });
  };
  return {
    trackEvent: trackEvent
  };
}
export function useManageApplicationEventTracker() {
  var eventPrefix = 'Single Application V2 - Manage Application Menu - ';
  var _useEventTracker4 = useEventTracker(),
    trackEventBase = _useEventTracker4.trackEvent;
  var trackEvent = function trackEvent(event) {
    return trackEventBase({
      event: "".concat(eventPrefix).concat(event.event),
      data: event.data,
      group: 'Single Application V2'
    });
  };
  return {
    trackEvent: trackEvent
  };
}